import axios from "axios"
import { logOut } from "../actions/AuthAction";
import store from '../store/ReduxStore';

const API = axios.create();

API.interceptors.response.use(
    response => response, 
    error => {
        if (error.response && error.response.status === 401) {
            console.log("Token expired, logging out user...");

            // Dispatch logout action
            store.dispatch(logOut());
        }
        return Promise.reject(error);
    }
);

export const uploadImage = (data) => {
      
    API.post(process.env.REACT_APP_MEDIA_UPLOAD_URL, data)
    .then((response)=>console.log(response))
    .catch((error)=>{
        console.log(error)
    });
}